module.exports = __webpack_public_path__ + "static/servicios_1-2660f8a0fd89a1a926ad63435ecadbf2.jpg";